import { TaskStatus } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { getFiBankStore } from 'stores/FiBankStore';
import { useFiTaskCache } from 'tanstack-hooks/fi-tasks/tasks-cache';
import { FI_TASK_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { DateTimeHelpers } from 'util/dateTime.util';

export function useCompleteFiTask() {
  const { user, userBankId } = useUser();
  const { invalidateTaskDetails, applyTaskUpdates } = useFiTaskCache();
  const timezone = getFiBankStore().bank.iana_timezone;
  const tasksApi = new TasksApi();

  const { mutateAsync: completeFiTask, isPending: isCompleteFiTaskPending } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: ({ taskId, completedNote }: { taskId: string; completedNote: string }) =>
      tasksApi.updateFiTask(
        userBankId,
        taskId,
        TaskStatus.COMPLETE,
        completedNote,
        user?.id ?? '',
        DateTimeHelpers.formatJsDateToISO(new Date(), timezone)
      ),
    onSuccess: (updatedTasks, { taskId }) => {
      applyTaskUpdates(updatedTasks);
      invalidateTaskDetails([taskId]);
    },
    meta: {
      snackbarErrorMessage:
        'There was a problem completing the task. Please try again or contact our help desk!'
    }
  });

  return { completeFiTask, isCompleteFiTaskPending };
}
